export default {
  'titleTxt': 'Login',
  'emailTitle': 'An email is on its way!',
  'recoverText': `Unable to access your HireVibes profile?<br />Message us by clicking the blue chat widget at the bottom of the screen`,
  'labelEmail': 'Email',
  'buttonLogin': 'Login',
  'emailError': 'Invalid email',
  'weSentTo': 'We sent an email to',
  'magicLinkDetail': 'Inside, you will find a magic link that will sign you in to HireVibes. This link expires in 24 hours, so be sure to use it soon. Go forth and check your email, friend.',
  'weSentAn': 'We sent an email to you Inside, you will find a magic link that will connect your Hiro Wallet to HireVibes. This link expires in 24 hours, so be sure to use it soon. Go forth and check your email, friend.'
}



// WEBPACK FOOTER //
// ./src/i18n/es/login.js